import { useContext } from 'react';

import { Button } from '@mui/material';

import { ConfirmDialog } from '../../../components/dialogs';
import { AlertSnackbarContext } from '../../../components/snackbars';
import { useRemoveAdditionalParentCategory } from '../../../lib/post/hooks';

type RemoveParentCategoryButtonProps = {
  parentCategoryId: string;
  postId: string;
};

function RemoveParentCategoryButton({ parentCategoryId, postId }: RemoveParentCategoryButtonProps) {
  const [, setAlert] = useContext(AlertSnackbarContext);
  const { mutateAsync: removeAdditionalParentCategory, isLoading: isSubmitting } = useRemoveAdditionalParentCategory();

  const handleSubmit = async () => {
    await removeAdditionalParentCategory(
      { postId, parentCategoryId },
      {
        onSuccess: () => {
          setAlert({ message: 'Parent category removed successfully', severity: 'success' });
        },
      },
    );
  };

  return (
    <ConfirmDialog
      trigger={(open) => (
        <Button onClick={open} variant="outlined" color="error" size="small" type="button">
          Remove
        </Button>
      )}
      title="Remove Parent Category"
      description="Are you sure you want to remove this parent category?"
      cancelBtnText={'Cancel'}
      submitBtnText={'Submit'}
      onConfirm={async (close) => {
        await handleSubmit();
        close();
      }}
      disabled={isSubmitting}
      loading={isSubmitting}
    />
  );
}

export default RemoveParentCategoryButton;
